import React from 'react'
import ProjectDashboard from '../../../Components/Dashboard/Project'

export default function Project() {
  return (
    <div className='page-body main-project'>
        <ProjectDashboard/>
    </div>
  )
}
